exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#rg-widget-compact{position:fixed;z-index:99999;opacity:1;width:192px;background-color:rgba(0,0,0,0);display:block;transition:all .5s ease-in-out;transform:translateY(0)}#rg-widget-compact.is-hidden{opacity:0;transform:translateY(100vh)}@media only screen and (max-width: 720px){#rg-widget-compact{width:215px;height:117px}}.rgwdg-tooltip{position:fixed;z-index:1000;border-radius:6px;background:#1c1b1f;display:flex;height:22px;padding:4px 8px;justify-content:center;align-items:center;color:#fff;font-size:12px;font-family:\"Source Sans Pro\",sans-serif,serif;font-style:normal;font-weight:400;line-height:normal}", ""]);

// exports
